<div
  class="time-display-container"
  ngbDropdown
  placement="top"
  [container]="isFullscreen ? null : 'body'"
  #timeFormatDropdown="ngbDropdown">
  <button type="button" class="time-display-btn" ngbDropdownToggle aria-haspopup="listbox">
    <span class="time-text">{{ displayTime }} / {{ displayDuration }}</span>
  </button>

  <div ngbDropdownMenu class="time-format-dropdown-menu" role="listbox">
    <button
      type="button"
      ngbDropdownItem
      class="time-format-dropdown-item"
      [class.active]="displayFormat === 'Frames'"
      (click)="setFormat('Frames'); timeFormatDropdown.close()">
      Frames
    </button>
    <button
      type="button"
      ngbDropdownItem
      class="time-format-dropdown-item"
      [class.active]="displayFormat === 'Seconds'"
      (click)="setFormat('Seconds'); timeFormatDropdown.close()">
      Seconds
    </button>
  </div>
</div>
